export class ApiUrls {
    public static readonly PingUrl: string = '/api/dev/ping';
    public static readonly AttachmentDownloadUrl = '/api/Attachment/download';

    public static readonly JobStopUrl: string = '/api/job/stop';
    public static readonly JobStartUrl: string = '/api/job/start';
    public static readonly JobParametersUrl: string = '/api/job/parameters';
    public static readonly JobTriggerCreateUrl: string = '/api/job/create';
    public static readonly JobTriggerDeleteUrl: string = '/api/job/delete';
    public static readonly CheckTriggerNameUrl: string = '/api/job/check-trigger-name';
    public static readonly JobCronValidation: string = '/api/job/cron/validation';

    public static readonly PermissionRoleUrl: string = '/api/permission/role';

    public static readonly PrimaryCostAccrualDownloadUrl: string = '/api/PrimaryCostAccrual/download-accruals-by-reporting-period';
    public static readonly PrimaryCostAccrualExportByReportIdUrl: string = '/api/PrimaryCostAccrual/report';
    public static readonly PrimaryCostAccrualItemImportTemplateByReportIdUrl: string = '/api/PrimaryCostAccrualItem/import-template';
    public static readonly PrimaryCostReportItemImportTemplateByReportIdUrl: string = '/api/PrimaryCostReportItem/import-template';
    public static readonly ServiceAccrualDownloadUrl: string = '/api/ServiceAccrual/export-accruals-outflow';
    public static readonly ServiceAccrualExportByReportIdUrl: string = '/api/ServiceAccrual/report';

    public static readonly EmployeeGapReportDownloadUrl: string = 'api/EmployeeGapReportItemPerson/export-employee-gap-report';

    public static readonly PrimaryCostInvoicingInflowInvoiceDownloadUrl: string = '/api/PrimaryCostInvoice/export-invoices';
    public static readonly PrimaryCostAInvoiceDownloadUrl: string = '/api/PrimaryCostInvoice/report';
    public static readonly PrimaryCostInvoiceQuarterAttachmentsDownloadUrl: string = '/api/PrimaryCostInvoice/quarter-attachments';
    public static readonly AttachmentDownloadAllInvoicesUrl: string = '/api/PrimaryCostInvoice/invoice-attachments';
    public static readonly ServiceInvoicesOutflowDownloadUrl: string = '/api/ServiceInvoice/export-invoices-outflow';
    public static readonly ServiceInvoicesDownloadUrl: string = '/api/ServiceInvoice/report';
}
